import gql from "graphql-tag";

export const GET_CLIENT_MENU_TYPE = gql`
  query menuType {
    Menu {
      menuType
      pdfUrl
    }
  }
`;
export const GET_CLIENT_MENU = gql`
  query getCustomerMenu($id: uuid!) {
    Menu(where: { id: { _eq: $id } }) {
      pdfUrl
      name
      User {
        stripeAccountId
      }
      id
      bannerUrl
      Categories(order_by: { sortIndex: asc }) {
        id
        name
        Dishes(order_by: { sortIndex: asc }) {
          availableFrom
          availableTo
          categoryId
          createdAt
          description
          id
          inStock
          name
          photoUrl
          price
          sortIndex
          DishModifiers(order_by: { sortIndex: asc }) {
            id
            Modifier {
              id
              itemMax
              name
              totalMax
              totalMin
              ModifierItems(order_by: { sortIndex: asc }) {
                name
                price
                sortIndex
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ORDER_DISH = gql`
  query getOrderDish {
    OrderDish(order_by: { createdAt: asc }) {
      count
      createdAt
      dishId
      id
      Dish {
        name
        id
        price
        categoryId
      }
      OrderDishModifierItems(order_by: { createdAt: asc }) {
        count
        id
        modifierItemId
        ModifierItem {
          name
          price
          id
        }
      }
    }
  }
`;

export const GET_ORDER_STATUS = gql`
  query getOrderStatus($id: uuid) {
    Order(where: { id: { _eq: $id } }) {
      status
      number
      cache
    }
  }
`;
